import { render } from "./LegalDocument.vue?vue&type=template&id=d537de2c&scoped=true"
import script from "./LegalDocument.vue?vue&type=script&lang=js"
export * from "./LegalDocument.vue?vue&type=script&lang=js"

import "./LegalDocument.vue?vue&type=style&index=0&id=d537de2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d537de2c"]])

export default __exports__